module.exports = __webpack_public_path__ + "static/img/14.e52397c8.png";